export const PATH_PARTIAL_REFUND_ADD = '';

export const REDUCER_NAME = 'partial-refund';



// WEBPACK FOOTER //
// ./src/modules/partial-refund/state/const.js